export const TOGGLE_LEAD_MODAL = 'TOGGLE_LEAD_MODAL';
export const TOGGLE_TASK_MODAL = 'TOGGLE_TASK_MODAL';
export const SET_TASK_MODAL_ERRORS = 'SET_TASK_MODAL_ERRORS';
export const TOGGLE_ALERT = 'TOGGLE_ALERT';
export const TOGGLE_ALL_FILTERS_MODAL = 'TOGGLE_ALL_FILTERS_MODAL';

export function toggleAllFiltersModal() {
  return { type: TOGGLE_ALL_FILTERS_MODAL };
}

export function hideLeadModal() {
  return ({ type: TOGGLE_LEAD_MODAL, showModal: false, lead: null });
}

export function showUpdateLeadModal(lead) {
  return ({ type: TOGGLE_LEAD_MODAL, showModal: true, lead: lead });
}

export const TOGGLE_LEAD_MODAL_ALERT = 'TOGGLE_LEAD_MODAL_ALERT';
export function showLeadModalAlert(errorMessage) {
  return ({ type: TOGGLE_LEAD_MODAL_ALERT, showAlert: true, errorMessage });
}

export function hideLeadModalAlert() {
  return ({ type: TOGGLE_LEAD_MODAL_ALERT, showAlert: false });
}

export function showNewTaskModal(lead) {
  return ({ type: TOGGLE_TASK_MODAL, showTaskModal: true, lead: lead, isLogged: false });
}

export function showLogTaskModal(lead) {
  return ({ type: TOGGLE_TASK_MODAL, showTaskModal: true, lead: lead, isLogged: true });
}

export function hideTaskModal() {
  return ({ type: TOGGLE_TASK_MODAL, showTaskModal: false, lead: null, isLogged: null });
}

export const setTaskModalErrors = errors => ({ type: SET_TASK_MODAL_ERRORS, errors });

export function toggleAlert(message, error) {
  return { type: TOGGLE_ALERT, message, error };
}
